import { Tooltip as ReactTooltip, type PlacesType } from "react-tooltip";
import { twMerge } from "tailwind-merge";
import * as React from "react";

export type PopoverProps = {
  content?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  align?: "start" | "center" | "end";
  position?: "top" | "bottom" | "left" | "right";
};

function toPlace(
  position: NonNullable<PopoverProps["position"]>,
  align: NonNullable<PopoverProps["align"]>,
): PlacesType {
  if (align === "center") return position;
  return `${position}-${align}` as PlacesType;
}

export default function Popover({
  content,
  children,
  className,
  contentClassName,
  align = "center",
  position = "bottom",
}: PopoverProps) {
  const popoverId = React.useId().replace(/:/g, "");

  if (!content) return <>{children}</>;

  return (
    <>
      <span
        data-tooltip-id={popoverId}
        className={twMerge("inline-flex cursor-pointer", className)}
      >
        {children}
      </span>
      <ReactTooltip
        id={popoverId}
        place={toPlace(position, align)}
        variant="light"
        positionStrategy="fixed"
        clickable
        opacity={1}
        className={twMerge("popover-panel", contentClassName)}
        content={content}
      />
    </>
  );
}
